import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { COMPANY_INFO, LOGO_SVG } from '../constants';

import LOGO_PNG from '../assets/logo.png'

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header>
      <nav>
        <Link to="/" className="logo" onClick={closeMenu}>
          <div className="logo-icon">
            {/* <img src={LOGO_SVG} alt="TopFluxe Logo" /> */}
            <img src={LOGO_PNG} alt="TopFluxe Logo"></img>
          </div>
          <span>{COMPANY_INFO.name}</span>
        </Link>
        <button 
          className="nav-toggle" 
          aria-label="Toggle navigation"
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" className={isActive('/')} onClick={closeMenu}>Home</Link></li>
          <li><Link to="/services" className={isActive('/services')} onClick={closeMenu}>Services</Link></li>
          <li><Link to="/work" className={isActive('/work')} onClick={closeMenu}>Our Work</Link></li>
          <li><Link to="/about" className={isActive('/about')} onClick={closeMenu}>About</Link></li>
          <li><Link to="/contact" className="btn" onClick={closeMenu}>Let's Talk</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;